import { create } from "zustand";
import { MarketModeDataActions, MarketModeState } from "./types";
import { queryClient } from "../../config/query-client";
import { createJSONStorage, persist } from "zustand/middleware";
import { activeModule } from "../active-module";

const initialState: MarketModeState = {
  mode: "market",
  expressPointId: null,
};

const useMarketExpressDataState = create<MarketModeState & MarketModeDataActions>()(
  persist<MarketModeState & MarketModeDataActions>(
    (set) => {
      return {
        ...initialState,

        setExpressPointId: (id: string) => {
          set((state) => {
            return { ...state, expressPointId: id };
          });
          queryClient.invalidateQueries(["products"]);
        },

        toggleMode: (value) => {
          set((state) => {
            return { ...state, mode: value };
          });
        },

        resetExpressPointId: () => {
          set((state) => {
            return { ...state, expressPointId: null };
          });
          queryClient.invalidateQueries(["products"]);
        },

        reset: () => {
          set(initialState);
        },
      };
    },
    {
      name: `${activeModule}-market-express-data`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

const useMarketExpressData = () => {
  return useMarketExpressDataState((state) => ({
    ...state,
  }));
};

export { useMarketExpressData, useMarketExpressDataState };
